import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState
} from 'react';

interface CsvDownloadContextType {
  downloadFileId: string | undefined;
  setDownloadFileId: Dispatch<SetStateAction<string | undefined>>;
  selectedRange: string | undefined;
  setSelectedRange: Dispatch<SetStateAction<string | undefined>>;
}

const CsvDownloadContext = createContext<CsvDownloadContextType | undefined>(undefined);

export const CsvDownloadProvider = ({ children }: { children: ReactNode }) => {
  const [downloadFileId, setDownloadFileId] = useState<string>();
  const [selectedRange, setSelectedRange] = useState<string>();

  const value = useMemo(
    () => ({
      downloadFileId,
      setDownloadFileId,
      selectedRange,
      setSelectedRange
    }),
    [downloadFileId, selectedRange]
  );

  return <CsvDownloadContext.Provider value={value}>{children}</CsvDownloadContext.Provider>;
};

export const useCsvDownloadContext = () => {
  const context = useContext(CsvDownloadContext);
  if (!context) throw new Error('useCsvDownloadContext must be used within CsvDownloadProvider');
  return context;
};
